import ApiClient from "src/utils/ApiClient";
import reportErrorToNewRelic from "src/Pages/Company/OrganizationStructure/utils/NewRelicReporter/reportErrorToNewRelic";
import { DASHBOARD_ROUTES } from "src/Pages/Company/Dashboard/services/api/apiRoutes";
import {
  DashboardModuleConfigurationDTO,
  DashboardModuleConfigurationPayload,
} from "src/Pages/Company/Dashboard/services/api/api.models";

export const DashboardApiClient = new ApiClient({
  baseURL: "/api/mybenefit-dashboard/omb",
  headers: {},
}).client;

DashboardApiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    reportErrorToNewRelic(error, "Dashboard API error");

    return Promise.reject(error);
  }
);

export const fetchDashboardModuleConfiguration = async (
  companyId: string
): Promise<DashboardModuleConfigurationDTO> => {
  const { data } = await DashboardApiClient.get(
    DASHBOARD_ROUTES.GET.DASHBOARD_MODULE_CONFIGURATION(companyId)
  );

  return data;
};

export const updateDashboardModuleConfiguration = async ({
  companyId,
  payload,
}: {
  companyId: string;
  payload: DashboardModuleConfigurationPayload;
}) => {
  const { data } = await DashboardApiClient.put(
    DASHBOARD_ROUTES.PUT.DASHBOARD_MODULE_CONFIGURATION(companyId),
    payload
  );

  return data;
};
